import SpinnerIcon from '@components/atoms/SpinnerIcon';
import React from 'react';

interface IProps {
    message?: string;
}

export default function LoadingBanner(props: IProps): JSX.Element {
    return (
        <div className='bg-blue-400/10 p-3 text-center h-12 text-base mb-6'>
            <div className='inline-flex items-center font-normal text-blue-700'>
                <SpinnerIcon className='h-5 w-5 text-blue-700 mr-2' />
                <span>{props.message ?? 'Loading...'}</span>
            </div>
        </div>
    );
}
